<template>
	<main
		id="main-content"
		tabindex="-1"
		class="layout-default h-100"
	>
		<slot />
	</main>
</template>
